import { AnimatePresence, motion } from "motion/react";

import { useApp } from "@/contexts/AppContext";

/**
 * Full-screen brand interstitial shown while the language switches.
 * The "?" is the SEEN brand mark, animated in the brand palette.
 */
export function LanguageLoader() {
  const { transitioning } = useApp();

  return (
    <AnimatePresence>
      {transitioning && (
        <motion.div
          key="lang-loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-background/95 backdrop-blur-md"
          role="status"
          aria-live="polite"
        >
          <div className="relative flex items-center justify-center">
            {/* Pulsing halo rings */}
            {[0, 0.45].map((delay) => (
              <motion.span
                key={delay}
                initial={{ scale: 0.6, opacity: 0.5 }}
                animate={{ scale: 1.6, opacity: 0 }}
                transition={{ duration: 1.8, repeat: Infinity, delay, ease: "easeOut" }}
                className="absolute h-40 w-40 rounded-full border border-golden-latte/40"
              />
            ))}

            <motion.span
              initial={{ scale: 0.5, opacity: 0, rotate: -14 }}
              animate={{ scale: 1, opacity: 1, rotate: 0 }}
              exit={{ scale: 0.85, opacity: 0 }}
              transition={{ type: "spring", stiffness: 160, damping: 14 }}
              className="relative select-none font-display-lg text-[120px] leading-none sm:text-[168px]"
            >
              {/* Gold shimmer sweeping through the glyph itself */}
              <motion.span
                initial={{ backgroundPosition: "200% 0" }}
                animate={{ backgroundPosition: "-200% 0" }}
                transition={{ duration: 1.6, repeat: Infinity, ease: "linear" }}
                className="bg-[linear-gradient(100deg,#3d2314_0%,#3d2314_35%,#c5a059_50%,#3d2314_65%,#3d2314_100%)] bg-[length:200%_100%] bg-clip-text text-transparent"
              >
                ?
              </motion.span>
            </motion.span>

          </div>

          <div className="mt-10 h-px w-40 overflow-hidden bg-outline-variant/40">
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              transition={{ duration: 1.5, ease: "easeInOut" }}
              className="h-full w-full bg-golden-latte"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
